/**
 * @generated SignedSource<<e26c6287e6deddbff996a38b74e0fdef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePartialItems_item$data = ReadonlyArray<{
  readonly isPartialItem: boolean | null;
  readonly medianL3SoldItemPriceScore: number | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "usePartialItems_item";
}>;
export type usePartialItems_item$key = ReadonlyArray<{
  readonly " $data"?: usePartialItems_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePartialItems_item">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "usePartialItems_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPartialItem",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medianL3SoldItemPriceScore",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "75b4876154fd18434d9fc2612b0ef0e8";

export default node;
